import React, { useEffect, useState } from "react";
import PublicLayout from "../components/PublicLayout";
import api from "../lib/api";
import { ShoppingBag } from "lucide-react";
import { Badge } from "../components/ui/badge";

export default function Store() {
  const [products, setProducts] = useState([]);
  useEffect(() => { api.get("/products").then((r) => setProducts(r.data)).catch(() => {}); }, []);

  return (
    <PublicLayout>
      <section className="bg-navy topo-bg">
        <div className="mx-auto max-w-7xl px-5 py-20 lg:px-8">
          <span className="eyebrow text-exploration">H.E.A. Shop</span>
          <h1 className="mt-3 font-display text-4xl font-extrabold text-white lg:text-5xl">Wear the Adventure</h1>
          <p className="mt-4 max-w-xl text-white/70">Premium H.E.A. apparel families actually want to wear. Preorders open now.</p>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-5 py-16 lg:px-8">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {products.map((p) => (
            <div key={p.id} data-testid={`product-${p.id}`} className="overflow-hidden rounded-2xl border border-slate-200 bg-white card-lift">
              <div className="flex h-52 items-center justify-center bg-cloud">
                <ShoppingBag className="h-16 w-16 text-navy/20" />
              </div>
              <div className="p-6">
                <div className="flex items-start justify-between">
                  <h3 className="font-display font-bold text-navy">{p.name}</h3>
                  {p.preorder && <Badge className="bg-gold/15 text-[#8A5F00] border-gold/40">Preorder</Badge>}
                </div>
                <div className="mt-3 text-sm text-slateBrand">Member <span className="font-semibold text-navy">${p.member_price}</span> · <span className="font-semibold text-navy">${p.price}</span></div>
                <div className="mt-2 text-xs text-slateBrand">{(p.variants || []).join(" · ")}</div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
}
